import { Socket } from 'socket.io-client';
import { createSocket } from './socket-init';

export class SocketManager {
  private static instance: Socket;

  public static getSocket(): Socket {
    if (!this.instance) {
      this.instance = createSocket({
        game: 'starwars',
        role: 'player' // Cette valeur sera remplacée par les paramètres spécifiques lors de la connexion
      });
    }
    return this.instance;
  }
}

export const socket = SocketManager.getSocket();

// Export a function to check connection status
export const isConnected = () => socket.connected;

// Export a function to manually reconnect
export const reconnect = () => {
  if (!socket.connected) {
    socket.connect();
  }
};

// Export a function to disconnect
export const disconnect = () => {
  if (socket.connected) {
    socket.disconnect();
  }
};
